<template>
<div>
<img src="../assets/DAILY-FRED-LOGO-JOSEPHINE_SANS_a9c4bb34-58aa-408c-b57e-75cc1749408c.png" class="block m-auto w-1/3 mb-4">
  <Survey />
</div>
</template>

<script>
// @ is an alias to /src
import Survey from '@/components/Survey.vue'

export default {
  name: 'Home',
  components: {
    Survey
  }
}
</script>